import { useEffect, useRef, useState } from 'react';

export default function MonitoringSelector({ accounts = [], selfId, value, onChange, isMobile }) {
  const [open, setOpen] = useState(false);
  const root = useRef(null);
  const selectedId = value == null ? Number(selfId) : Number(value);
  const own = accounts.find(account => Number(account.id) === Number(selfId));
  const selected = accounts.find(account => Number(account.id) === selectedId) || own;

  useEffect(() => { setOpen(false); }, [selectedId]);

  useEffect(() => {
    if (!open) return undefined;
    const closeOutside = event => {
      if (!root.current?.contains(event.target)) setOpen(false);
    };
    const closeEscape = event => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('pointerdown', closeOutside);
    document.addEventListener('keydown', closeEscape);
    return () => {
      document.removeEventListener('pointerdown', closeOutside);
      document.removeEventListener('keydown', closeEscape);
    };
  }, [open]);

  if (!selfId || !own) return null;

  const label = selected?.name || own.name || 'Mi cuenta';

  return (
    <div ref={root} style={{ position: 'relative', minWidth: 0, pointerEvents: 'auto' }}>
      <button
        type="button"
        aria-label={`Monitoreo: ${label}. Elegir cuenta`}
        aria-expanded={open}
        aria-haspopup="true"
        onClick={() => setOpen(previous => !previous)}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          gap: 5, maxWidth: isMobile ? '100%' : 210, minHeight: 38,
          margin: isMobile ? '0 auto' : 0, padding: '0 6px',
          border: 0, borderRadius: 10,
          background: open ? 'rgba(255,255,255,.88)' : 'transparent',
          color: isMobile ? '#063b78' : '#ffffff',
          fontSize: isMobile ? 17 : 13, fontWeight: 850,
          cursor: 'pointer', WebkitTapHighlightColor: 'transparent'
        }}
      >
        <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis',
          whiteSpace: 'nowrap', textShadow: isMobile ? '0 1px 2px #ffffff' : 'none' }}>
          {label}
        </span>
        <span aria-hidden="true" style={{ flexShrink: 0, fontSize: 15,
          transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 150ms' }}>
          ▾
        </span>
      </button>

      {open && (
        <div role="menu" aria-label="Cuentas para monitoreo" style={{
          position: 'absolute', top: 'calc(100% + 7px)',
          left: isMobile ? '50%' : 'auto', right: isMobile ? 'auto' : 0,
          transform: isMobile ? 'translateX(-50%)' : 'none',
          width: isMobile ? 'min(310px, calc(100vw - 28px))' : 300,
          maxHeight: isMobile ? 'min(48dvh, 370px)' : 'min(60vh, 430px)',
          overflowY: 'auto', WebkitOverflowScrolling: 'touch',
          boxSizing: 'border-box', padding: 6,
          borderRadius: 16, border: '1px solid rgba(148,163,184,.28)',
          background: 'rgba(250,253,255,.98)',
          boxShadow: '0 15px 38px rgba(15,23,42,.24)',
          zIndex: 2147483001
        }}>
          <div style={{ padding: '7px 10px 5px', color: '#64748b', fontSize: 10,
            fontWeight: 900, letterSpacing: '.6px' }}>MONITOREAR CUENTA</div>
          {[own, ...accounts.filter(account => Number(account.id) !== Number(selfId))]
            .map(account => (
              <button
                key={account.id}
                type="button"
                role="menuitemradio"
                aria-checked={Number(account.id) === selectedId}
                onClick={() => {
                  setOpen(false);
                  if (Number(account.id) !== selectedId) onChange(Number(account.id));
                }}
                style={{
                  width: '100%', display: 'flex', alignItems: 'center', gap: 9,
                  padding: '11px 10px', border: 0, borderRadius: 10,
                  background: Number(account.id) === selectedId ? '#e0efff' : 'transparent',
                  color: '#0f172a', textAlign: 'left', cursor: 'pointer',
                  fontSize: 13, fontWeight: Number(account.id) === selectedId ? 900 : 700
                }}
              >
                <span style={{ flex: 1, minWidth: 0, overflowWrap: 'anywhere' }}>
                  {Number(account.id) === Number(selfId)
                    ? `Mi cuenta · ${account.name}` : account.name}
                </span>
                {Number(account.id) === selectedId && <span aria-hidden="true">✓</span>}
              </button>
            ))}
        </div>
      )}
    </div>
  );
}
